"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LookupService = function () {
  function LookupService($http, $q, appConfig) {
    "ngInject";

    var storageProvider = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.sessionStorage;
    (0, _classCallCheck3.default)(this, LookupService);
    this.$http = $http;
    this.$q = $q;
    this.appConfig = appConfig;
    this.storageProvider = storageProvider;
  }

  (0, _createClass3.default)(LookupService, [{
    key: "lookup",
    value: function lookup(lookupName, params) {
      var _this = this;

      var deferred = this.$q.defer();
      var lookupData = JSON.parse(this.storageProvider.getItem("lookups." + lookupName));
      var query = this.appConfig.apiServiceBaseUri + ("api/lookup/" + lookupName + "?");

      if (!lookupData || !lookupData.length) {
        if (params) {
          (0, _lodash.map)(params, function (itemValue, itemName) {
            query += itemName + "=" + itemValue + "&";
          });
        }

        this.$http.get(query).then(function (response) {
          if (!params) {
            _this.storageProvider.setItem("lookups." + lookupName, (0, _stringify2.default)(response.data.items));
          }

          deferred.resolve(response.data.items || response.data);
        }).catch(function (err) {
          deferred.reject(err);
        });
      } else {
        deferred.resolve(lookupData);
      }
      return deferred.promise;
    }
  }, {
    key: "lookupEnums",
    value: function lookupEnums(enumNames) {
      var _this2 = this;

      var deferred = this.$q.defer();
      var enumsToLookupFromServer = [];
      var enumLookupCollection = {};

      enumNames.map(function (enumName) {
        var lookupData = JSON.parse(_this2.storageProvider.getItem("lookups." + enumName.toCamelCase()));

        if (!lookupData || !lookupData.length) {
          enumsToLookupFromServer.push(enumName);
        } else {
          enumLookupCollection[enumName.toCamelCase()] = lookupData;
        }
      });

      if (enumsToLookupFromServer.length) {
        this.$http.get(this.appConfig.apiServiceBaseUri + ("api/lookup/enums?enumNames=" + enumsToLookupFromServer.toString())).then(function (response) {
          response.data.map(function (enumLookup) {
            enumLookupCollection[enumLookup.enumName.toCamelCase()] = enumLookup.values;
            _this2.storageProvider.setItem("lookups." + enumLookup.enumName.toCamelCase(), (0, _stringify2.default)(enumLookup.values));
          });
          deferred.resolve(enumLookupCollection);
        }).catch(function (err) {
          deferred.reject(err);
        });
      } else {
        deferred.resolve(enumLookupCollection);
      }

      return deferred.promise;
    }
  }, {
    key: "lookupRoles",
    value: function lookupRoles() {
      var deferred = this.$q.defer();

      var roles = [{ "roleId": 1, "name": "Administrator" }, { "roleId": 2, "name": "Sales Manager" }, { "roleId": 3, "name": "Sales Rep" }, { "roleId": 4, "name": "Showroom Host" }, { "roleId": 5, "name": "Accounts Admin" }];

      deferred.resolve(roles);

      return deferred.promise;
    }
  }, {
    key: "lookupBrands",
    value: function lookupBrands() {
      return this.lookup('brands');
    }
  }, {
    key: "lookupBrandModels",
    value: function lookupBrandModels() {
      return this.lookup('brandModels');
    }
  }, {
    key: "lookupPriceLookups",
    value: function lookupPriceLookups(entityId) {
      return this.lookup('priceLookups', {
        entityId: entityId
      });
    }
  }, {
    key: "lookupAccessoryLookups",
    value: function lookupAccessoryLookups(entityId, locationOnly) {
      return this.lookup('accessoryLookups', {
        entityId: entityId,
        locationOnly: locationOnly ? true : false
      });
    }
  }, {
    key: "lookupEnquiryPrices",
    value: function lookupEnquiryPrices(entityId) {
      return this.lookup('enquiryPrices', {
        entityId: entityId
      });
    }
  }, {
    key: "lookupEntityNamesByIds",
    value: function lookupEntityNamesByIds(entityIds) {
      return this.lookup('entityNameLookup', {
        entityIds: entityIds
      });
    }
  }, {
    key: "lookupVehicleByRegNo",
    value: function lookupVehicleByRegNo(locationId, vehicleCondition, regNo, validate) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/lookup/vehicle/" + locationId + "/" + vehicleCondition + "/" + regNo + "/" + validate));
    }
  }, {
    key: "lookupMyLocations",
    value: function lookupMyLocations(locationId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/lookup/mylocations/" + locationId));
    }
  }]);
  return LookupService;
}();

exports.default = LookupService;


// WEBPACK FOOTER //
// ./client/app/common/services/lookupService.js